// extracted by mini-css-extract-plugin
module.exports = {"donutWrapper":"Donut_donutWrapper__3X5qQ","donutName":"Donut_donutName__8eFO2"};